import { Component, OnInit, Inject, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatListOption } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { pageKey, validSelected, autoComplete, pushToArray, getHour, getMinute, toHour, hourToNumber } from 'src/app/services/mapping.service';
import { statusObj, DAYS } from 'src/app/dummy/status';
import { Observable } from 'rxjs';
import { ISession } from 'src/app/interfaces/country';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-session',
  templateUrl: './add-session.component.html',
  styleUrls: ['./add-session.component.scss']
})
export class AddSessionComponent implements OnInit {
  @ViewChild("focus", { static: false }) inputRef: ElementRef;
  @ViewChildren(MatListOption) options: QueryList<MatListOption>;

  meridian = true;
  HH = getHour(new Date())
  MM = getMinute(new Date())
  fromHourModel = { hour: this.HH, minute: this.MM };
  toHourModel = { hour: this.HH, minute: this.MM };

  form: FormGroup;
  shift: AbstractControl;
  name: AbstractControl;
  description: AbstractControl;
  day: AbstractControl;

  filteredStates: Observable<any[]>;
  DAYS_LIST = DAYS
  constructor(
    public dialogRef: MatDialogRef<AddSessionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
    public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      shift: [null, Validators.compose([Validators.required, validSelected.bind(this)])],
      name: [null, Validators.required],
      description: [null],
      day: [null, Validators.required],
    });
    this.shift = this.form.controls['shift'];
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];

    const shifts = await this.ds.shiftRef().get().toPromise();
    this.filteredStates = autoComplete(this.shift, pushToArray(shifts), 'name');
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) return o1.key === o2.key;
  }

  create(f: any, DAYS: any, isNew: boolean) {
    if (this.form.valid) {
      this.form.disable()
      const { shift, name, description, day } = f;
      const item: ISession = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        description: description,
        status: statusObj.active,
        days: day,
        fromHour: toHour(this.fromHourModel),
        toHour: toHour(this.toHourModel),
        fromHourKey: hourToNumber(this.fromHourModel),
        toHourKey: hourToNumber(this.toHourModel),
        shift: this.ds.shiftRef().doc(`${shift.key}`).ref,
        shiftRef: this.ds.shiftRef().doc(`${shift.key}`).ref,
        shiftKey: shift.key,
      }

      this.store.save(this.ds.sessionRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Session has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.form.patchValue({
            shift
          })
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }

  }

}
